const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const SHORT_LINK_HOSTS = new Set(["youtu.be", "www.youtu.be"]);
const FULL_HOSTS = new Set([
  "youtube.com",
  "www.youtube.com",
  "m.youtube.com",
  "youtube-nocookie.com",
  "www.youtube-nocookie.com",
]);
/** Path forms that carry the id as the second segment: /embed/ID, /shorts/ID, /live/ID, /v/ID. */
const ID_PATH_PREFIXES = new Set(["embed", "shorts", "live", "v"]);

// Privacy-enhanced mode: YouTube sets no tracking cookies until the visitor presses play.
const EMBED_BASE_URL = "https://www.youtube-nocookie.com/embed/";
const THUMBNAIL_BASE_URL = "https://i.ytimg.com/vi/";

function toUrl(value: string): URL | null {
  try {
    return new URL(value.trim());
  } catch {
    return null;
  }
}

function candidateId(url: URL): string | null | undefined {
  const host = url.hostname.toLowerCase();
  const [first, second] = url.pathname.split("/").filter(Boolean);
  if (SHORT_LINK_HOSTS.has(host)) return first;
  if (!FULL_HOSTS.has(host)) return null;
  if (first === "watch") return url.searchParams.get("v");
  return first && ID_PATH_PREFIXES.has(first) ? second : null;
}

/**
 * The 11-character video id from any common YouTube link (watch, youtu.be, shorts, live, embed),
 * or null when the link is not a YouTube video. Used to validate the admin input and to build
 * the embed, so only an id ever reaches the iframe URL.
 */
export function parseYouTubeVideoId(link: string): string | null {
  const url = toUrl(link);
  if (!url || (url.protocol !== "https:" && url.protocol !== "http:")) return null;
  const id = candidateId(url);
  return id && VIDEO_ID_PATTERN.test(id) ? id : null;
}

export function youTubeEmbedUrl(videoId: string): string {
  return `${EMBED_BASE_URL}${videoId}?autoplay=1&rel=0&modestbranding=1`;
}

export function youTubeThumbnailUrl(videoId: string): string {
  return `${THUMBNAIL_BASE_URL}${videoId}/hqdefault.jpg`;
}
